import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Display-only formatter for Agreed Commission.
 * Rules:
 *   - 10   -> "10%"
 *   - 5    -> "5%"
 *   - 12.5 -> "12.5%"
 *   - empty / null / undefined -> "N/A"
 *   - already contains "%" -> returned as-is (no double "%")
 * Never mutates the stored value; pure display transform.
 */
export function formatCommission(value) {
  if (value === null || value === undefined || value === "") return "N/A";
  const str = String(value).trim();
  if (str === "") return "N/A";
  if (str.includes("%")) return str; // prevent double formatting
  const num = parseFloat(str);
  if (Number.isNaN(num)) return "N/A";
  return `${num}%`;
}
